import styled, { css } from 'styled-components';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

// Import components
import { WatermarkImage } from 'components/elements';

export const Image = styled(WatermarkImage)`
	${customMinResponsive(
		size.medium,
		css`
			margin-top: 0.4rem;
		`
	)}
`;

export const Button = styled.button`
	border: none;
	background: transparent;
	cursor: pointer;
	margin-right: 2.35rem;
	${flex({ ai: 'start' })};

	&:focus-visible {
		outline: 2px dashed ${({ theme }) => theme.outline.focusColor};
	}
`;
